var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#EDEFF0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m11.996 15.661 5.764-3.484-5.764-2.675-5.756 2.675 5.756 3.484Z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11.996 9.502V2.4L6.24 12.177l5.756 3.484V9.502Z",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m11.997 15.661 5.763-3.484L11.997 2.4v13.262Z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11.996 16.775 6.24 13.3l5.756 8.301v-4.825Z",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m17.76 13.299-5.763 3.476V21.6l5.763-8.302Z",
    opacity: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEth);
export default __webpack_public_path__ + "static/media/eth.1f2a34b549dffb0613a86205798c87a7.svg";
export { ForwardRef as ReactComponent };